import { CustomerPortal } from 'api/customer-portal/types';

export interface LiveCustomerPortal {
  contextValues: Record<string, unknown>;
  portal: CustomerPortal;
  projectId: number;
  id: 'new';
  currentPage: string;
}

export class LiveCustomerPortalModel implements LiveCustomerPortal {
  contextValues: Record<string, unknown>;

  portal: CustomerPortal;

  projectId: number;

  id: 'new';

  currentPage: string;

  constructor(lcp: LiveCustomerPortal) {
    this.contextValues = lcp.contextValues;
    this.portal = lcp.portal;
    this.id = lcp.id;
    this.projectId = lcp.projectId;
    this.currentPage = lcp.currentPage;
  }
}
